import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { ROLE_UK_USER } from '../shared/constants';
import { DeclarationsAuthService } from './declarations-auth.service';

@Component({
  selector: 'ad-uk-user',
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    @if (isAuthorized) {
      <span> <ng-content></ng-content></span>
    }
  `
})
export class UkUserComponent implements OnInit {
  public isAuthorized!: boolean;

  constructor(private authService: DeclarationsAuthService) {}

  ngOnInit(): void {
    this.authService.hasRole$(ROLE_UK_USER).subscribe((hasRole) => (this.isAuthorized = hasRole));
  }
}
